import { cleanObject } from '@shared/utils/cleanObject.js';

// Helper function to capitalize headers keys properly
const capitalizeHeaderKeys = (headers) => {
  if (!headers || typeof headers !== 'object') return headers;

  return Object.entries(headers).reduce((acc, [key, value]) => {
    const capitalizedKey = key
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('-');
    acc[capitalizedKey] = value;
    return acc;
  }, {});
};

const getOutputHeaders = (response) => {
  if (!response) {
    return {};
  }

  const { config, headers, request, status } = response;
  const requestUrl = request ? `${request?.protocol?.replace(/:$/, '')}://${request?.host}${request?.path}` : undefined;
  const method = request?.method;

  const generalHeaders = cleanObject({
    'Request URL': requestUrl,
    'Request Method': method,
    'Status Code': status,
    'Referrer Policy': 'strict-origin-when-cross-origin'
  });

  const result = {
    General: generalHeaders,
    'Response Headers': capitalizeHeaderKeys(headers),
    'Request Headers': capitalizeHeaderKeys(config?.headers)
  };

  return cleanObject(result);
};

export default getOutputHeaders;
